import React from "react";

const CommentsListItemFooter = ({
  canReply,
  replyClick,
  replyTranslation,
  likedCount,
  dislikedCount,
  like,
  dislike
}) => (
  <div className="a-reaction flex items-center f--3 t-mt2 lh-solid">
    {canReply && (
      <a
        className="link f--3 blue fw4 ttu t-pr3"
        href={EMPTY_HREF}
        onClick={replyClick}
      >
        {replyTranslation}
      </a>
    )}
    {like}
    <span className="t-pr2">{likedCount}</span>
    {dislike}
    <span>{dislikedCount}</span>
  </div>
);

CommentsListItemFooter.defaultProps = {
  canReply: false,
  replyClick: null,
  replyTranslation: "Reply",
  like: "like button",
  likedCount: 0,
  dislikedCount: 0,
  dislike: "dislike button"
};

export default CommentsListItemFooter;
